var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "brb-modal" },
    [
      !_vm.noActivator
        ? _vm._t(
            "activator",
            function () {
              return [
                !_vm.noActivator
                  ? _c(
                      _vm.activatorTag,
                      _vm._b(
                        {
                          tag: "component",
                          attrs: { text: _vm.activatorLabel },
                          on: { click: _vm.show },
                        },
                        "component",
                        _vm.activatorAttrs,
                        false
                      )
                    )
                  : _vm._e(),
              ]
            },
            { show: _vm.show, hide: _vm.hide }
          )
        : _vm._e(),
      _c(
        "b-modal",
        _vm._g(
          _vm._b(
            {
              attrs: {
                "content-class": [
                  "rounded-modal",
                  { "overflow-hidden": !_vm.showOverflow },
                ],
                "body-class": "p-0",
                "hide-header": "",
                "hide-footer": "",
              },
              model: {
                value: _vm.open,
                callback: function ($$v) {
                  _vm.open = $$v
                },
                expression: "open",
              },
            },
            "b-modal",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        [
          !_vm.noHeader
            ? _c(
                "div",
                {
                  staticClass:
                    "head d-flex align-items-center justify-content-between bg-light p-3",
                },
                [
                  _vm._t(
                    "header",
                    function () {
                      return [
                        _c(
                          "h4",
                          { staticClass: "text-muted p-0 m-0 single-line" },
                          [_vm._v(" " + _vm._s(_vm.title) + " ")]
                        ),
                      ]
                    },
                    { show: _vm.show, hide: _vm.hide }
                  ),
                  _vm.closeButton
                    ? _c(
                        "b-btn",
                        {
                          attrs: {
                            variant: "link",
                            size: "sm",
                            disabled: _vm.loading,
                          },
                          on: { click: _vm.hide },
                        },
                        [
                          _c("font-awesome-icon", {
                            staticClass: "text-muted align-middle",
                            attrs: { icon: "times" },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                2
              )
            : _vm._e(),
          _c(
            "b-overlay",
            { attrs: { show: _vm.loading } },
            [
              _vm._t("default"),
              !_vm.noFooter
                ? _c(
                    "div",
                    {
                      staticClass:
                        "foot d-flex align-items-center justify-content-end bg-light p-3",
                    },
                    [
                      _vm._t("footer-start"),
                      _vm._t(
                        "footer",
                        function () {
                          return [
                            _c(
                              "b-btn",
                              {
                                staticClass: "px-4 ml-2",
                                attrs: { variant: "danger" },
                                on: { click: _vm.cancel },
                              },
                              [_vm._v(" " + _vm._s(_vm.cancelLabel) + " ")]
                            ),
                            _c(
                              "b-btn",
                              {
                                staticClass: "px-4",
                                attrs: { variant: "success" },
                                on: {
                                  click: function ($event) {
                                    return _vm.$emit("submit", {
                                      show: _vm.show,
                                      hide: _vm.hide,
                                    })
                                  },
                                },
                              },
                              [_vm._v(" " + _vm._s(_vm.submitLabel) + " ")]
                            ),
                          ]
                        },
                        { show: _vm.show, hide: _vm.hide }
                      ),
                    ],
                    2
                  )
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }